export const frameDetails = (id: string, frames: any[]) => {
  const find = frames.find((frame) => frame.id === id);
  if (find) {
    return find;
  }
  return {};
};
